import { render, staticRenderFns } from "./RightTool.vue?vue&type=template&id=ca034d4c&scoped=true"
import script from "./RightTool.vue?vue&type=script&lang=js"
export * from "./RightTool.vue?vue&type=script&lang=js"
import style0 from "./RightTool.vue?vue&type=style&index=0&id=ca034d4c&prod&lang=scss"
import style1 from "./RightTool.vue?vue&type=style&index=1&id=ca034d4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca034d4c",
  null
  
)

export default component.exports